// DT1 (refactor por tamaño): cuerpo de campos extraído a subcomponente presentacional.
import { UsuarioFormCampos } from "../components/UsuarioFormCampos";
// Estado, handlers y carga inicial viven en el hook del caso de uso.
import { useUsuarioForm } from "../hooks/usuarioForm/useUsuarioForm";

export const UsuarioForm = () => {

    const {
        accesos,
        accion,
        imagenbase,
        handleSubmit,
        onSubmitCrear,
        onSubmitEditar,
        cancelar,
        register,
        errors,
        watch,
        listaCompanias,
        listaSucursales,
        listaSedes,
        listaTipoDocumento,
        sedesSeleccionadas,
        setSedesSeleccionadas,
        errorSedes,
        setErrorSedes,
        obtenerSucursalesPorCompania,
        obtenerSedesPorSucursal,
        cambiarTipoDocumento,
        handleInputChange,
        maxLengthInput,
        rol,
    } = useUsuarioForm()

    return (
        <div className="p-3">
            <div className="container-fluid">
                <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Usuario</h3>
                <div className="row mt-3">
                    <div className="col-12 col-lg-9 mx-auto mt-0">
                        {/* Formulario */}

                        <form id="CreateForm" onSubmit={accion === "agregar" ? handleSubmit(onSubmitCrear) : handleSubmit(onSubmitEditar)} className="row g-2 p-1">

                            <UsuarioFormCampos
                                accion={accion}
                                imagenbase={imagenbase}
                                handleSubmit={handleSubmit}
                                onSubmitCrear={onSubmitCrear}
                                onSubmitEditar={onSubmitEditar}
                                register={register}
                                errors={errors}
                                watch={watch}
                                listaCompanias={listaCompanias}
                                listaSucursales={listaSucursales}
                                listaSedes={listaSedes}
                                listaTipoDocumento={listaTipoDocumento}
                                sedesSeleccionadas={sedesSeleccionadas}
                                setSedesSeleccionadas={setSedesSeleccionadas}
                                errorSedes={errorSedes}
                                setErrorSedes={setErrorSedes}
                                obtenerSucursalesPorCompania={obtenerSucursalesPorCompania}
                                obtenerSedesPorSucursal={obtenerSedesPorSucursal}
                                cambiarTipoDocumento={cambiarTipoDocumento}
                                handleInputChange={handleInputChange}
                                maxLengthInput={maxLengthInput}
                                rol={rol}
                                accesos={accesos}
                            />
                        </form>


                        <div className='mt-4 botones-accion text-center'>
                            {
                                accion === "agregar" && (
                                    <button className='btn btn-sm btn-primario col-md-2' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitCrear)}>Guardar</button>
                                )
                            }
                            {
                                accion === "editar" && (
                                    <button className='btn btn-sm btn-primario col-md-2' type="submit" form="CreateForm" onClick={handleSubmit(onSubmitEditar)}>Guardar</button>
                                )
                            }
                            <button className='btn btn-sm btn-secundario col-md-2' onClick={cancelar}>Cancelar</button>

                        </div>
                        {/* Fin formulario */}
                    </div >

                </div>

                {/*
                    mostrar && (
                        <div className="row mt-4">
                            <div className="col-lg-6 mx-auto text-center alert-error">
                                <Stack spacing={2}>
                                    <Alert variant="outlined" severity={tipoAlerta} >{mensaje}</Alert>
                                </Stack>
                            </div>
                        </div>

                    )
                */}

            </div>
        </div>
    )
}
